import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-create-resultados-evaluaciones',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './create-resultados-evaluaciones.component.html',
  styleUrl: './create-resultados-evaluaciones.component.css',
})
export class CreateResultadosEvaluacionesComponent {
  id_evaluacion: any;
  file: File | null = null;
  result: any = null;
  errorMessage: string | null = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      //console.log(this.file); // Agrega esto para verificar el archivo
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.id_evaluacion = params['id_evaluacion'];
    });
  }

  onSubmit(event: Event) {
    event.preventDefault(); // Prevenir recarga de la página

    if (!this.file) {
      this.errorMessage = 'Por favor, selecciona un archivo.';
      return;
    }

    const formData = new FormData();
    formData.append('file', this.file);

    this.http
      .post(
        environment.apiUrl +
          '/resultado-evaluacion/upload/' +
          this.id_evaluacion,
        formData
      )
      .subscribe({
        next: (response) => {
          this.result = response;
          this.errorMessage = null;
          //console.log('Archivo subido con éxito:', response);
        },
        error: (error) => {
          this.errorMessage = 'Error al subir el archivo. Inténtalo de nuevo.';
          //console.error('Error:', error);
        },
      });
  }
  volver(): void {
    this.router.navigate(['/historial-evaluacion'], {
      queryParams: { id_evaluacion: this.id_evaluacion },
    });
  }
}
